import { createLifecycleFor } from "actions/account/collections";

const TYPE = "analyticsV2";
export const { callApi: getAnalytics, patterns, replace, send, append, reject } = createLifecycleFor(
  TYPE
);
